import PolicyItem from "./PolicyItem";
export default PolicyItem;